import { render } from "./MenuListComponentOld.vue?vue&type=template&id=76753d40&scoped=true"
import script from "./MenuListComponentOld.vue?vue&type=script&lang=js"
export * from "./MenuListComponentOld.vue?vue&type=script&lang=js"

import "./MenuListComponentOld.vue?vue&type=style&index=0&id=76753d40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76753d40"]])

export default __exports__